let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dvoU9")).then(() => parcelRequire('77vyI'));